import http, { batchUrl } from "@/utils/request";

export function imageUpload(data: any) {
  return http.post<Res.response<any>>({
    url: batchUrl,
    data,
  });
}
